import { Box, Flex, Heading, Image } from "@chakra-ui/react";
import { ReactNode, createContext, useContext, useRef, useState } from "react";

import { useOnlyOnce } from "@nens/react/hooks";

import { PAGE_HEIGHT_PX, REPORT_BLOCK_GAP } from "../consts/sizes";

const PageCounterContext = createContext<{ next: () => number } | null>(null);

export const ReportPagesProvider = ({ children }: { children: ReactNode }) => {
  const counterRef = useRef(0);
  counterRef.current = 0;

  const ctxValue = useRef<{ next: () => number }>({
    next: () => ++counterRef.current,
  }).current;

  return <PageCounterContext.Provider value={ctxValue}>{children}</PageCounterContext.Provider>;
};

export const ReportPage = ({ children }: { children: ReactNode }) => {
  const ctx = useContext(PageCounterContext);
  const [pageNumber, setPageNumber] = useState<number | null>(null);
  useOnlyOnce(() => {
    if (pageNumber === null && ctx) {
      setPageNumber(ctx.next());
    }
  });

  return (
    <Flex
      mb={20}
      sx={{
        "@media print": {
          mb: 0,
        },
      }}
      flexDir="column"
      gap={REPORT_BLOCK_GAP}
      h={PAGE_HEIGHT_PX + "px"}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Image alt="klimaatscan logo" h="50px" mb={2} src="/assets/images/klimaatscan-logo.png" />
        <Heading as="h4" size="h4">
          Rapportage
        </Heading>
      </Flex>

      {children}

      <Flex
        color="#999999"
        fontSize="xs"
        mt="auto"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box>
          De data die gebruikt wordt om de labels te bepalen is gebaseerd op zorgvuldig
          samengestelde en benaderde waarden die de werkelijkheid zo goed mogelijk representeren.
          Desondanks kunnen afwijkingen voorkomen. De weergegeven resultaten dienen te worden
          beschouwd als indicatief; er kunnen geen rechten aan worden ontleend. Deze tool is
          uitsluitend bedoeld ter ondersteuning van besluitvorming en niet als exacte weergave van
          de werkelijkheid.
        </Box>
        {pageNumber !== null && (
          <Box flexShrink={0} ml={4}>
            Pagina: {pageNumber}
          </Box>
        )}
      </Flex>
    </Flex>
  );
};
